var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnlimitedRecipes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unlimited_recipes",
    "data-name": "Unlimited recipes",
    transform: "translate(-15 -15)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3720",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 143",
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    fill: "#fff7b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3909",
    "data-name": "Group 3909",
    transform: "translate(28 27.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1388",
    "data-name": "Group 1388",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1315",
    "data-name": "Group 1315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1314",
    "data-name": "Group 1314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M20.135,39.338H8.011V8.206H30.147v8.73a.978.978,0,0,0,1.956,0V7.228a.978.978,0,0,0-.978-.978H7.033a.978.978,0,0,0-.978.978V40.316a.978.978,0,0,0,.978.978h13.1a.978.978,0,0,0,0-1.956",
    transform: "translate(-6.055 -6.25)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M21.72,47.285H18.263a.978.978,0,1,0,0,1.956H21.72a.978.978,0,1,0,0-1.956",
    transform: "translate(-12.787 -30.851)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M21.72,59.277H18.263a.978.978,0,1,0,0,1.956H21.72a.978.978,0,1,0,0-1.956",
    transform: "translate(-12.787 -38.04)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M21.72,70.293H18.263a.978.978,0,1,0,0,1.956H21.72a.978.978,0,1,0,0-1.956",
    transform: "translate(-12.787 -44.644)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M25,25.6a.977.977,0,0,0-1.385,0l-3.7,3.7-.978-.985A.979.979,0,0,0,17.558,29.7l1.674,1.674a.977.977,0,0,0,1.385,0L25,26.989A.977.977,0,0,0,25,25.6",
    transform: "translate(-12.779 -17.681)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M55.248,58.338a4.212,4.212,0,0,1-2.66-.993.976.976,0,0,0-1.228,0,4.211,4.211,0,0,1-2.66.993c-3,0-5.28-3.293-5.28-7.212s2.284-7.212,5.28-7.212a4.211,4.211,0,0,1,2.66.993.976.976,0,0,0,1.228,0,4.212,4.212,0,0,1,2.66-.993c3,0,5.28,3.293,5.28,7.212s-2.284,7.212-5.28,7.212m0-16.38a5.78,5.78,0,0,0-1.971.344,6.052,6.052,0,0,1,.305-.9,3.016,3.016,0,0,1,1.353-1.6.98.98,0,0,0-.876-1.752c-1.65.821-2.479,2.7-2.84,4.482a5.932,5.932,0,0,0-2.519-.571c-3.911,0-7.235,4.044-7.235,9.167s3.332,9.168,7.251,9.168a6.006,6.006,0,0,0,3.27-.986,6.007,6.007,0,0,0,3.27.986c3.911,0,7.236-4.044,7.236-9.168s-3.325-9.167-7.243-9.167",
    transform: "translate(-27.283 -25.25)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M55.45,57.422l-.782.782a.979.979,0,1,0,1.385,1.385l.782-.782a.979.979,0,0,0-1.385-1.385",
    transform: "translate(-35.026 -36.755)",
    fill: "#121e59"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlimitedRecipes);
export default __webpack_public_path__ + "static/media/unlimitedRecipes.bed13ef252d9b2108cd648b438839c56.svg";
export { ForwardRef as ReactComponent };